export default __webpack_public_path__ + "static/media/password-generator.40ef064a.png";